
import React, { useState } from 'react';
import { Header } from '../../components/feature/Header';

const TravelAuthorityPage = () => {
  const [searchData, setSearchData] = useState({
    destination: '',
    checkIn: '',
    checkOut: '',
    guests: 1,
    rooms: 1,
    tripType: 'roundtrip',
    departureDate: '',
    returnDate: '',
    travelers: 1,
    class: 'economy'
  });

  const [activeTab, setActiveTab] = useState('hotels');

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setSearchData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle search logic here
    console.log('Search data:', searchData);
  };

  const popularDestinations = [
    {
      name: 'Paris, France',
      image: 'https://public.readdy.ai/ai/img_res/948ed193e4c8ba58b52bf34b6a862b06.jpg',
      price: 'From $899'
    },
    {
      name: 'Tokyo, Japan',
      image: 'https://readdy.ai/api/search-image?query=Modern%20Tokyo%20skyline%20with%20traditional%20temples%2C%20cherry%20blossoms%2C%20bustling%20city%20life%2C%20neon%20lights%2C%20cultural%20blend&width=300&height=200&seq=tokyo1&orientation=landscape',
      price: 'From $1,299'
    },
    {
      name: 'New York, USA',
      image: 'https://readdy.ai/api/search-image?query=New%20York%20City%20Manhattan%20skyline%2C%20iconic%20buildings%2C%20Central%20Park%2C%20urban%20energy%2C%20modern%20architecture&width=300&height=200&seq=nyc1&orientation=landscape',
      price: 'From $699'
    },
    {
      name: 'London, England',
      image: 'https://readdy.ai/api/search-image?query=London%20cityscape%20with%20Big%20Ben%2C%20Thames%20River%2C%20historic%20architecture%2C%20red%20buses%2C%20British%20culture&width=300&height=200&seq=london1&orientation=landscape',
      price: 'From $799'
    },
    {
      name: 'Dubai, UAE',
      image: 'https://readdy.ai/api/search-image?query=Dubai%20modern%20skyline%20with%20Burj%20Khalifa%2C%20luxury%20hotels%2C%20desert%20landscape%2C%20futuristic%20architecture&width=300&height=200&seq=dubai1&orientation=landscape',
      price: 'From $1,099'
    },
    {
      name: 'Rome, Italy',
      image: 'https://readdy.ai/api/search-image?query=Ancient%20Rome%20with%20Colosseum%2C%20historic%20ruins%2C%20Italian%20architecture%2C%20Mediterranean%20atmosphere%2C%20cultural%20heritage&width=300&height=200&seq=rome1&orientation=landscape',
      price: 'From $749'
    }
  ];

  const travelDeals = [
    {
      title: 'European Adventure',
      description: '7 days in Paris, Rome & Barcelona',
      image: 'https://readdy.ai/api/search-image?query=European%20travel%20collage%20with%20famous%20landmarks%2C%20Eiffel%20Tower%2C%20Colosseum%2C%20Sagrada%20Familia%2C%20cultural%20destinations&width=400&height=250&seq=europe1&orientation=landscape',
      price: '$1,899',
      originalPrice: '$2,499',
      savings: 'Save $600'
    },
    {
      title: 'Asian Discovery',
      description: '10 days in Tokyo, Kyoto & Osaka',
      image: 'https://readdy.ai/api/search-image?query=Japan%20travel%20experience%20with%20traditional%20temples%2C%20modern%20cities%2C%20cherry%20blossoms%2C%20cultural%20attractions&width=400&height=250&seq=japan1&orientation=landscape',
      price: '$2,299',
      originalPrice: '$2,899',
      savings: 'Save $600'
    },
    {
      title: 'Caribbean Escape',
      description: '5 days in Barbados all-inclusive',
      image: 'https://readdy.ai/api/search-image?query=Caribbean%20tropical%20paradise%20with%20crystal%20clear%20water%2C%20white%20sand%20beaches%2C%20palm%20trees%2C%20luxury%20resort&width=400&height=250&seq=caribbean1&orientation=landscape',
      price: '$1,199',
      originalPrice: '$1,599',
      savings: 'Save $400'
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      
      {/* Hero Section with Search */}
      <section className="relative bg-gradient-to-r from-blue-600 to-purple-700 text-white py-20">
        <div className="absolute inset-0 bg-black/20"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h1 className="text-5xl font-bold mb-6">Business Development Authority Inc.</h1>
            <h2 className="text-3xl font-semibold mb-4">Travel Authority</h2>
            <p className="text-xl max-w-3xl mx-auto mb-8">
              Your premier destination for exceptional travel experiences and comprehensive travel management solutions.
            </p>
          </div>

          {/* Search Tabs */}
          <div className="max-w-4xl mx-auto">
            <div className="flex flex-wrap justify-center mb-6">
              <button
                onClick={() => setActiveTab('hotels')}
                className={`px-6 py-3 rounded-t-lg font-semibold transition-colors ${
                  activeTab === 'hotels' 
                    ? 'bg-white text-blue-600' 
                    : 'bg-blue-500 text-white hover:bg-blue-400'
                }`}
              >
                <i className="ri-hotel-line mr-2"></i>Hotels
              </button>
              <button
                onClick={() => setActiveTab('flights')}
                className={`px-6 py-3 rounded-t-lg font-semibold transition-colors ${
                  activeTab === 'flights' 
                    ? 'bg-white text-blue-600' 
                    : 'bg-blue-500 text-white hover:bg-blue-400'
                }`}
              >
                <i className="ri-plane-line mr-2"></i>Flights
              </button>
              <button
                onClick={() => setActiveTab('packages')}
                className={`px-6 py-3 rounded-t-lg font-semibold transition-colors ${
                  activeTab === 'packages' 
                    ? 'bg-white text-blue-600' 
                    : 'bg-blue-500 text-white hover:bg-blue-400'
                }`}
              >
                <i className="ri-suitcase-line mr-2"></i>Packages
              </button>
              <button
                onClick={() => setActiveTab('cars')}
                className={`px-6 py-3 rounded-t-lg font-semibold transition-colors ${
                  activeTab === 'cars' 
                    ? 'bg-white text-blue-600' 
                    : 'bg-blue-500 text-white hover:bg-blue-400'
                }`}
              >
                <i className="ri-car-line mr-2"></i>Car Rentals
              </button>
            </div>

            {/* Search Form */}
            <div className="bg-white rounded-lg p-6 shadow-xl">
              <form onSubmit={handleSearch}>
                {activeTab === 'hotels' && (
                  <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                    <div className="md:col-span-2">
                      <label className="block text-sm font-medium text-gray-700 mb-2">Destination</label>
                      <input
                        type="text"
                        name="destination"
                        value={searchData.destination}
                        onChange={handleInputChange}
                        placeholder="Where are you going?"
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Check-in</label>
                      <input
                        type="date"
                        name="checkIn"
                        value={searchData.checkIn}
                        onChange={handleInputChange}
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Check-out</label>
                      <input
                        type="date"
                        name="checkOut"
                        value={searchData.checkOut}
                        onChange={handleInputChange}
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Guests</label>
                      <select
                        name="guests"
                        value={searchData.guests}
                        onChange={handleInputChange}
                        className="w-full px-4 py-3 pr-8 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      >
                        {[1,2,3,4,5,6,7,8].map(num => (
                          <option key={num} value={num}>{num} Guest{num > 1 ? 's' : ''}</option>
                        ))}
                      </select>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Rooms</label>
                      <select
                        name="rooms"
                        value={searchData.rooms}
                        onChange={handleInputChange}
                        className="w-full px-4 py-3 pr-8 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      >
                        {[1,2,3,4,5].map(num => (
                          <option key={num} value={num}>{num} Room{num > 1 ? 's' : ''}</option>
                        ))}
                      </select>
                    </div>
                    <div className="md:col-span-2">
                      <button
                        type="submit"
                        className="w-full bg-blue-600 text-white py-3 px-6 rounded-lg hover:bg-blue-700 transition-colors font-semibold whitespace-nowrap"
                      >
                        <i className="ri-search-line mr-2"></i>Search Hotels
                      </button>
                    </div>
                  </div>
                )}

                {activeTab === 'flights' && (
                  <div className="space-y-4">
                    <div className="flex gap-4 mb-4">
                      <label className="flex items-center">
                        <input
                          type="radio"
                          name="tripType"
                          value="roundtrip"
                          checked={searchData.tripType === 'roundtrip'}
                          onChange={handleInputChange}
                          className="mr-2"
                        />
                        Round Trip
                      </label>
                      <label className="flex items-center">
                        <input
                          type="radio"
                          name="tripType"
                          value="oneway"
                          checked={searchData.tripType === 'oneway'}
                          onChange={handleInputChange}
                          className="mr-2"
                        />
                        One Way
                      </label>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">From</label>
                        <input
                          type="text"
                          placeholder="Departure city"
                          className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">To</label>
                        <input
                          type="text"
                          placeholder="Destination city"
                          className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">Departure</label>
                        <input
                          type="date"
                          name="departureDate"
                          value={searchData.departureDate}
                          onChange={handleInputChange}
                          className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                        />
                      </div>
                      {searchData.tripType === 'roundtrip' && (
                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-2">Return</label>
                          <input
                            type="date"
                            name="returnDate"
                            value={searchData.returnDate}
                            onChange={handleInputChange}
                            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                          />
                        </div>
                      )}
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">Travelers</label>
                        <select
                          name="travelers"
                          value={searchData.travelers}
                          onChange={handleInputChange}
                          className="w-full px-4 py-3 pr-8 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                        >
                          {[1,2,3,4,5,6,7,8].map(num => (
                            <option key={num} value={num}>{num} Traveler{num > 1 ? 's' : ''}</option>
                          ))}
                        </select>
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">Class</label>
                        <select
                          name="class"
                          value={searchData.class}
                          onChange={handleInputChange}
                          className="w-full px-4 py-3 pr-8 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                        >
                          <option value="economy">Economy</option>
                          <option value="premium">Premium Economy</option>
                          <option value="business">Business</option>
                          <option value="first">First Class</option>
                        </select>
                      </div>
                      <div>
                        <button
                          type="submit"
                          className="w-full bg-blue-600 text-white py-3 px-6 rounded-lg hover:bg-blue-700 transition-colors font-semibold whitespace-nowrap mt-6"
                        >
                          <i className="ri-search-line mr-2"></i>Search Flights
                        </button>
                      </div>
                    </div>
                  </div>
                )}

                {activeTab === 'packages' && (
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Destination</label>
                      <input
                        type="text"
                        placeholder="Where do you want to go?"
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Travel Dates</label>
                      <input
                        type="date"
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Duration</label>
                      <select className="w-full px-4 py-3 pr-8 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent">
                        <option>3-5 days</option>
                        <option>6-8 days</option>
                        <option>9-12 days</option>
                        <option>2+ weeks</option>
                      </select>
                    </div>
                    <div className="md:col-span-3">
                      <button
                        type="submit"
                        className="w-full bg-blue-600 text-white py-3 px-6 rounded-lg hover:bg-blue-700 transition-colors font-semibold whitespace-nowrap"
                      >
                        <i className="ri-search-line mr-2"></i>Search Packages
                      </button>
                    </div>
                  </div>
                )}

                {activeTab === 'cars' && (
                  <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Pick-up Location</label>
                      <input
                        type="text"
                        placeholder="City or airport"
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Pick-up Date</label>
                      <input
                        type="date"
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Return Date</label>
                      <input
                        type="date"
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      />
                    </div>
                    <div>
                      <button
                        type="submit"
                        className="w-full bg-blue-600 text-white py-3 px-6 rounded-lg hover:bg-blue-700 transition-colors font-semibold whitespace-nowrap mt-6"
                      >
                        <i className="ri-search-line mr-2"></i>Search Cars
                      </button>
                    </div>
                  </div>
                )}
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Popular Destinations */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Popular Destinations</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Discover amazing destinations around the world with our expertly crafted travel packages.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {popularDestinations.map((destination, index) => (
              <div key={index} className="relative group overflow-hidden rounded-lg shadow-lg cursor-pointer">
                <img
                  src={destination.image}
                  alt={destination.name}
                  className="w-full h-64 object-cover group-hover:scale-110 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                <div className="absolute bottom-4 left-4 text-white">
                  <h3 className="text-xl font-bold mb-1">{destination.name}</h3>
                  <p className="text-sm">{destination.price}</p>
                </div>
                <div className="absolute top-4 right-4">
                  <button className="bg-white bg-opacity-20 hover:bg-opacity-30 rounded-full p-2 transition-colors">
                    <i className="ri-heart-line text-white"></i>
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Travel Deals */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Exclusive Travel Deals</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Limited-time offers on our most popular travel packages. Book now and save big!
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {travelDeals.map((deal, index) => (
              <div key={index} className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
                <div className="relative">
                  <img
                    src={deal.image}
                    alt={deal.title}
                    className="w-full h-48 object-cover"
                  />
                  <div className="absolute top-4 left-4 bg-red-500 text-white px-3 py-1 rounded-full text-sm font-semibold">
                    {deal.savings}
                  </div>
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-2">{deal.title}</h3>
                  <p className="text-gray-600 mb-4">{deal.description}</p>
                  <div className="flex items-center justify-between mb-4">
                    <div className="flex items-center space-x-2">
                      <span className="text-2xl font-bold text-blue-600">{deal.price}</span>
                      <span className="text-lg text-gray-500 line-through">{deal.originalPrice}</span>
                    </div>
                  </div>
                  <button className="w-full bg-blue-600 text-white py-3 px-6 rounded-lg hover:bg-blue-700 transition-colors font-semibold whitespace-nowrap">
                    Book Now
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section id="services" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Our Travel Services</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              From corporate travel management to luxury vacation planning, we provide comprehensive travel solutions.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-white rounded-lg shadow-lg p-8 hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 bg-blue-600 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-plane-line text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">Corporate Travel</h3>
              <p className="text-gray-600 mb-6">
                Streamlined business travel solutions with cost optimization and policy compliance management.
              </p>
              <ul className="space-y-2 text-gray-600">
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-2"></i>
                  Flight & hotel bookings
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-2"></i>
                  Expense management
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-2"></i>
                  24/7 support
                </li>
              </ul>
            </div>

            <div className="bg-white rounded-lg shadow-lg p-8 hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 bg-purple-600 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-map-2-line text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">Vacation Planning</h3>
              <p className="text-gray-600 mb-6">
                Personalized vacation experiences tailored to your preferences and budget requirements.
              </p>
              <ul className="space-y-2 text-gray-600">
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-2"></i>
                  Custom itineraries
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-2"></i>
                  Luxury accommodations
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-2"></i>
                  Activity planning
                </li>
              </ul>
            </div>

            <div className="bg-white rounded-lg shadow-lg p-8 hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 bg-green-600 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-group-line text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">Group Travel</h3>
              <p className="text-gray-600 mb-6">
                Specialized group travel coordination for conferences, events, and team building activities.
              </p>
              <ul className="space-y-2 text-gray-600">
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-2"></i>
                  Event coordination
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-2"></i>
                  Group discounts
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-2"></i>
                  Transportation logistics
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Contact & Social Media Section */}
      <section id="contact" className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Start Planning Your Journey</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Ready to explore the world? Contact our travel experts to begin planning your perfect trip.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-8">Contact Information</h3>
              <div className="space-y-6">
                <div className="flex items-center space-x-4">
                  <div className="w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center">
                    <i className="ri-phone-line text-white text-xl"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">Phone</h4>
                    <p className="text-gray-600 text-lg">916 257 8244</p>
                  </div>
                </div>

                <div className="flex items-center space-x-4">
                  <div className="w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center">
                    <i className="ri-mail-line text-white text-xl"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">Email</h4>
                    <p className="text-gray-600">info@travelauthority.com</p>
                  </div>
                </div>

                <div className="flex items-center space-x-4">
                  <div className="w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center">
                    <i className="ri-linkedin-fill text-white text-xl"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">LinkedIn</h4>
                    <a 
                      href="https://www.linkedin.com/in/jeffery-long-23b02a38a/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-blue-600 hover:text-blue-700 transition-colors"
                    >
                      Connect with me
                    </a>
                  </div>
                </div>

                <div className="flex items-center space-x-4">
                  <div className="w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center">
                    <i className="ri-calendar-line text-white text-xl"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">Schedule Consultation</h4>
                    <a href="/calendar" className="text-blue-600 hover:text-blue-700 transition-colors">
                      Book Now
                    </a>
                  </div>
                </div>
              </div>

              {/* Social Media Links */}
              <div className="mt-8">
                <h4 className="text-lg font-semibold text-gray-900 mb-4">Connect on Social Media</h4>
                <div className="flex space-x-4">
                  <a
                    href="https://www.linkedin.com/in/jeffery-long-23b02a38a/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center text-white hover:bg-blue-700 transition-colors"
                  >
                    <i className="ri-linkedin-fill text-xl"></i>
                  </a>
                  <a
                    href="#"
                    className="w-12 h-12 bg-blue-500 rounded-full flex items-center justify-center text-white hover:bg-blue-600 transition-colors"
                  >
                    <i className="ri-facebook-fill text-xl"></i>
                  </a>
                  <a
                    href="#"
                    className="w-12 h-12 bg-blue-400 rounded-full flex items-center justify-center text-white hover:bg-blue-500 transition-colors"
                  >
                    <i className="ri-twitter-fill text-xl"></i>
                  </a>
                  <a
                    href="#"
                    className="w-12 h-12 bg-pink-600 rounded-full flex items-center justify-center text-white hover:bg-pink-700 transition-colors"
                  >
                    <i className="ri-instagram-fill text-xl"></i>
                  </a>
                </div>
              </div>

              {/* Back to Business Pages */}
              <div className="mt-8 p-6 bg-gray-50 rounded-lg">
                <h4 className="text-lg font-semibold text-gray-900 mb-4">Explore My Other Services</h4>
                <div className="space-y-2">
                  <a href="/real-estate" className="block text-blue-600 hover:text-blue-700 transition-colors">
                    <i className="ri-arrow-right-line mr-2"></i>Real Estate Development
                  </a>
                  <a href="/ai-consulting" className="block text-blue-600 hover:text-blue-700 transition-colors">
                    <i className="ri-arrow-right-line mr-2"></i>AI Consulting Authority
                  </a>
                  <a href="/ai-book" className="block text-blue-600 hover:text-blue-700 transition-colors">
                    <i className="ri-arrow-right-line mr-2"></i>AI Book Authority
                  </a>
                  <a href="/books" className="block text-blue-600 hover:text-blue-700 transition-colors">
                    <i className="ri-arrow-right-line mr-2"></i>Published Books
                  </a>
                </div>
              </div>
            </div>

            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Service Areas</h3>
              <p className="text-gray-600 mb-6">
                Serving travelers worldwide with headquarters in Northern California.
              </p>
              
              {/* Service Area Map */}
              <div className="aspect-video rounded-lg overflow-hidden shadow-lg">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d804686.2922526915!2d-122.3301083!3d38.5816223!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x809ac672b28397f9%3A0x921f6aaa74197fdb!2sSacramento%2C%20CA!5e0!3m2!1sen!2sus!4v1697000000000!5m2!1sen!2sus"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Service Areas Map"
                ></iframe>
              </div>
              
              <div className="mt-4 text-sm text-gray-600">
                <p><strong>Headquarters:</strong> Sacramento, California</p>
                <p><strong>Service Areas:</strong> Worldwide travel planning and management services</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-blue-600 to-purple-700 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold mb-6">Ready for Your Next Adventure?</h2>
          <p className="text-xl mb-8 max-w-3xl mx-auto">
            Let our travel experts create the perfect journey tailored to your dreams and budget.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="#services"
              className="bg-white text-blue-600 px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap"
            >
              Explore Services
            </a>
            <a
              href="/calendar"
              className="border-2 border-white text-white px-8 py-3 rounded-lg font-semibold hover:bg-white hover:text-blue-600 transition-colors whitespace-nowrap"
            >
              Schedule Consultation
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TravelAuthorityPage;